// 统一的剪贴板复制工具：navigator.clipboard 优先，textarea+execCommand 兜底
// 返回 Promise<{ ok: boolean, method: 'async' | 'execCommand' | 'failed' }>
export async function copyToClipboard(text) {
  // 优先用 async clipboard API（非微信场景最稳定）
  try {
    await navigator.clipboard.writeText(text);
    return { ok: true, method: 'async' };
  } catch {
    // 微信内置浏览器里 async clipboard 经常被拒，回退到 execCommand
  }
  try {
    const el = document.createElement('textarea');
    el.value = text;
    el.readOnly = true;
    // 离屏但仍可被 document.execCommand('copy') 选中（微信内置浏览器限制）
    el.style.position = 'fixed';
    el.style.top = '0';
    el.style.left = '0';
    el.style.width = '1px';
    el.style.height = '1px';
    el.style.padding = '0';
    el.style.border = 'none';
    el.style.outline = 'none';
    el.style.boxShadow = 'none';
    el.style.background = 'transparent';
    el.style.opacity = '0';
    document.body.appendChild(el);
    el.focus({ preventScroll: true });
    el.select();
    el.setSelectionRange(0, text.length);
    const ok = document.execCommand('copy');
    document.body.removeChild(el);
    return { ok, method: 'execCommand' };
  } catch {
    return { ok: false, method: 'failed' };
  }
}

// 金额格式化：统一返回两位小数字符串
export function fmtMoney(n) {
  return (Number(n) || 0).toFixed(2);
}

// 是否运行在微信内置浏览器内
export function inWeChatBrowser() {
  return /MicroMessenger/i.test(navigator.userAgent || '');
}

// 点击号码后，跳转微信首页（号码已复制，用户在微信搜索框粘贴即加好友）
// 与旧版（可正常跳转）写法完全一致：toast 后延时 300ms 再 window.location.href = 'weixin://'
// 注意：改成 <a> click 触发 / 多 scheme 尝试后反而失效，务必保持此最简写法
export function jumpToWeChat() {
  if (!inWeChatBrowser()) return false;
  setTimeout(() => { window.location.href = 'weixin://'; }, 300);
  return true;
}

// 工作时间文案模板替换（{start}/{end} 占位符）
export function renderNotice(tpl, settings) {
  if (!tpl || !settings) return tpl || '';
  const fmt = (h, m) => `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
  return tpl
    .replace(/\{start\}/g, fmt(settings.startHour, settings.startMinute))
    .replace(/\{end\}/g, fmt(settings.endHour, settings.endMinute));
}
